<script setup lang="ts">
	const props = defineProps<{
		iconText: string;
	}>();
</script>
<template>
	<i class="flex items-center justify-center">
		<svg
			width="27"
			height="32"
			viewBox="0 0 27 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clip-path="url(#clip0_111_6559)">
				<path
					d="M7.68033 27.2C7.06856 27.2 6.53327 26.96 6.07444 26.48C5.61562 26 5.38621 25.44 5.38621 24.8V2.4C5.38621 1.76 5.61562 1.2 6.07444 0.72C6.53327 0.24 7.06856 0 7.68033 0H24.5039C25.1156 0 25.6509 0.24 26.1097 0.72C26.5686 1.2 26.798 1.76 26.798 2.4V24.8C26.798 25.44 26.5686 26 26.1097 26.48C25.6509 26.96 25.1156 27.2 24.5039 27.2H7.68033ZM3.09209 32C2.48033 32 1.94503 31.76 1.48621 31.28C1.02739 30.8 0.797974 30.24 0.797974 29.6V4.8H3.09209V29.6H22.2097V32H3.09209Z"
					fill="#FF6105"
				/>
				<text
					x="16"
					y="16"
					text-anchor="middle"
					font-size="8"
					fill="white"
					font-family="Arial, sans-serif"
				>
					{{ props.iconText }}
				</text>
			</g>
			<defs>
				<clipPath id="clip0_111_6559">
					<rect
						width="26"
						height="32"
						fill="white"
						transform="translate(0.797974)"
					/>
				</clipPath>
			</defs>
		</svg>
	</i>
</template>
